import { FETCH_CACHED_COUNT, FETCH_CACHED_LOADS, FETCH_CACHED_LOADS_BY_STATUS, SET_NEW_LOADS_FILTERS } from './actions'
import { cachedLoadsPaginationSize, cachedLoadStateSchema } from './utils'

const initialState = {
  filters: {},
  negotiation: {
    ...cachedLoadStateSchema,
  },
  waitingCollect: {
    ...cachedLoadStateSchema,
  },
  inTransit: {
    ...cachedLoadStateSchema,
  },
  delivered: {
    ...cachedLoadStateSchema,
  },
  inProgress: {
    ...cachedLoadStateSchema,
  },
}

const newLoads = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CACHED_LOADS_BY_STATUS: {
      const { key, data, page, ...rest } = payload
      return {
        ...state,
        [key]: {
          ...state[key],
          list: page > 1 ? [...state[key].list, ...data] : data,
          hasMore: data.length >= cachedLoadsPaginationSize,
          page,
          ...rest,
        },
      }
    }
    case FETCH_CACHED_LOADS: {
      const mappedPayloadd = Object.entries(payload)
      const newState = mappedPayloadd
        .map(([key, value]) => ({
          [key]: {
            ...state[key],
            ...value,
          },
        }))
        .reduce((acc, current) => ({ ...acc, ...current }), {})
      return { ...state, ...newState }
    }
    case FETCH_CACHED_COUNT: {
      const { key, count } = payload
      return {
        ...state,
        [key]: {
          ...state[key],
          count,
        },
      }
    }
    case SET_NEW_LOADS_FILTERS: {
      return {
        ...state,
        filters: payload,
      }
    }
    default:
      return state
  }
}

export default newLoads
